import React from 'react';
export var TodoFooter = function (props) {
    var itemCount = Object.keys(props.todos).filter(function (id) { return !props.todos[id].completed; }).length;
    var _onClick = function () {
        props.clear();
    };
    return (React.createElement("footer", null,
        React.createElement("span", null,
            itemCount,
            " item",
            itemCount === 1 ? '' : 's',
            " left"),
        React.createElement("button", { onClick: _onClick, className: "submit" }, "Clear Completed")));
};
